const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-1/PNG%20n.4/3d%201-4/publish%201-4/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 1 Level 4 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
